/* Interaction motion for the redesigned pages (assets/BPS_kit.css). Arsalan 2026-10-21: reveal animations look
   unprofessional, so nothing fades in on load or scroll; the smoothness goes to the controls instead.
   Accordions (<details class="bk-acc">, the questions .fqp-item, the cart's .crt-acc and kit .crt-kit) open and close
   with a height animation and a soft fade of their content. The state still lives in [open], so page scripts and CSS
   keep working; .is-closing is on while a close runs. Reduced motion keeps the browser's instant toggle.
   Safe to include from several sections: it runs once. */
(function () {
  if (window.bpsKit) return;
  window.bpsKit = true;

  // A decorative texture (img.bk-tex) that fails to load would leave the browser's broken-image box over the band;
  // hide it instead, so the band's own colour shows.
  document.querySelectorAll('img.bk-tex').forEach(function (img) {
    function hide() { img.style.visibility = 'hidden'; }
    if (img.complete && !img.naturalWidth && img.currentSrc) hide();
    img.addEventListener('error', hide);
  });
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (calm || !Element.prototype.animate) return;

  var ACCORDIONS = 'details.bk-acc, details.fqp-item, details.crt-acc, details.crt-kit';
  var EASE = 'cubic-bezier(0.2, 0.7, 0.2, 1)';

  function stop(details) {
    (details.bkAnimations || []).forEach(function (animation) { animation.cancel(); });
    details.bkAnimations = null;
    details.style.overflow = '';
  }

  function toggle(details, summary) {
    var from = details.getBoundingClientRect().height;
    var running = !!details.bkAnimations;
    stop(details);
    // a click during a close opens it again; any other click on an open one closes it
    var closing = details.open && !(running && details.classList.contains('is-closing'));
    var style = window.getComputedStyle(details);
    // heights are measured as border boxes; a content-box element animates its content height
    var box = style.boxSizing === 'border-box' ? 0 : parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    var to;
    if (closing) {
      details.classList.add('is-closing');
      to = summary.getBoundingClientRect().bottom - details.getBoundingClientRect().top + parseFloat(style.paddingBottom) + parseFloat(style.borderBottomWidth);
    } else {
      details.classList.remove('is-closing');
      details.open = true;
      to = details.getBoundingClientRect().height;
    }

    details.style.overflow = 'hidden';
    var size = details.animate({ height: [(from - box) + 'px', (to - box) + 'px'] }, { duration: closing ? 260 : 380, easing: EASE });
    var animations = [size];
    Array.prototype.forEach.call(details.children, function (child) {
      if (child === summary) return;
      animations.push(child.animate({ opacity: closing ? [1, 0] : [0, 1] }, closing
        ? { duration: 220, easing: 'ease', fill: 'forwards' }
        : { duration: 320, delay: 60, easing: 'ease', fill: 'backwards' }));
    });
    details.bkAnimations = animations;
    size.onfinish = function () {
      if (closing) {
        details.open = false;
        details.classList.remove('is-closing');
      }
      stop(details);
    };
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button > 0) return;
    var summary = event.target.closest && event.target.closest('summary');
    if (!summary) return;
    // a link or button inside the summary does its own thing
    var inner = event.target.closest('a, button, input, select, textarea, label');
    if (inner && inner !== summary && summary.contains(inner)) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.matches(ACCORDIONS)) return;
    if (details.querySelector(':scope > summary') !== summary) return;
    event.preventDefault();
    toggle(details, summary);
  });
})();
